import { CSSProperties } from 'react';
import { CheckboxFormFieldComponent } from '@vivli/shared/components';
import { PublishedCitationComponent } from '@vivli/shared/features/citations/components';
import { Color, Size } from '@vivli/shared/theme';
import { ICitation } from '@vivli/shared/features/citations/infrastructure/interface';

const sectionStyle: CSSProperties = {
    overflowX: 'hidden',
    overflowY: 'auto',
    paddingLeft: 0,
    paddingRight: 0,
    display: 'flex',
    flexDirection: 'row',
    paddingBottom: Size.INSET_SIZE,
    paddingTop: 0,
    color: Color.VIVLI_PUBLISHED_DARKBLUE,
};

const sectionStyleContainerConfig: CSSProperties = {
    ...sectionStyle,
    display: 'grid',
    justifyContent: 'space-around',
    gridTemplateColumns: '48px 1fr',
    columnGap: '48px',
};

const disclosureListStyle: CSSProperties = {
    display: 'grid',
    gridAutoFlow: 'column',
    gridTemplateColumns: '24px 1fr',
    marginBottom: -20,
};

interface DisclosuresRowFormComponentProps {
    isConfigMode: boolean;
    citation: ICitation;
    fieldName: string;
    index: number;
}

export const DisclosuresRowFormComponent = ({ isConfigMode, citation, index, fieldName }: DisclosuresRowFormComponentProps) => {
    return (
        <>
            <div style={sectionStyleContainerConfig}>
                {isConfigMode && <CheckboxFormFieldComponent name={`${fieldName}.publishable`} style={{ alignSelf: 'start' }} />}
                <div>
                    <span style={disclosureListStyle}>
                        {index + 1}
                        {') '}
                        <PublishedCitationComponent citation={citation} />
                    </span>
                </div>
            </div>
        </>
    );
};
